import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[fieldAnchor]',
    standalone: false
})
export class FieldAnchorDirective {
  public readonly viewContainerRef = inject(ViewContainerRef);
}
